export const en: Record<string, string> = {
  'shell.navigation': 'Main navigation',
  'shell.group.overview': 'Overview',
  'shell.group.operations': 'Operations',
  'shell.group.people': 'People',
  'shell.group.communication': 'Communication',
  'shell.group.tools': 'Tools',
  'shell.lifecycle': 'Lifecycle',
  'shell.workspace': 'Workspace',
  'shell.openNavigation': 'Open navigation',
  'shell.closeNavigation': 'Close navigation',
  'shell.expandNavigation': 'Expand navigation',
  'shell.collapseNavigation': 'Collapse navigation',
  'shell.collapse': 'Collapse',
  'shell.language': 'Language',
  'shell.languageGerman': 'German',
  'shell.languageEnglish': 'English',
};

export const de: Record<string, string> = {
  'shell.navigation': 'Hauptnavigation',
  'shell.group.overview': 'Übersicht',
  'shell.group.operations': 'Betrieb',
  'shell.group.people': 'Personen',
  'shell.group.communication': 'Kommunikation',
  'shell.group.tools': 'Werkzeuge',
  'shell.lifecycle': 'Lebenszyklus',
  'shell.workspace': 'Arbeitsbereich',
  'shell.openNavigation': 'Navigation öffnen',
  'shell.closeNavigation': 'Navigation schließen',
  'shell.expandNavigation': 'Navigation ausklappen',
  'shell.collapseNavigation': 'Navigation einklappen',
  'shell.collapse': 'Einklappen',
  'shell.language': 'Sprache',
  'shell.languageGerman': 'Deutsch',
  'shell.languageEnglish': 'Englisch',
};
